module.exports = __webpack_public_path__ + "static/posAndOp-e77538eb28096f6034a4a092c10ffc4f.svg";